module.exports = __webpack_public_path__ + "img/aaaa.8d7e223e.png";